import 'babel-polyfill';
import $ from 'jquery';
/* eslint-disable */
import magnificPopup from 'magnific-popup';
/* eslint-enable */

const elements = {
  videos: [...document.body.querySelectorAll('.js-hero-video')],
};

function bindClose() {
  $.magnificPopup.close();
  this.removeEventListener('click', bindClose);
}

function bindVideoHero(el) {
  $(el).magnificPopup({
    callbacks: {
      close: () => {
        el.focus();
      },
      open: () => {
        document.querySelector('.js-video-hero-close').addEventListener('click', bindClose);
      },
    },
    focus: '.js-video-hero-close',
    iframe: {
      markup: `<div class="mfp-iframe-scaler">
          <div class="c-hero__video-close c-hero__video-close--iframe">
            <button type="button" class="c-hero__video-close-button js-video-hero-close">
              <svg class="c-hero__video-close-icon" focusable="false" aria-hidden="true">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use>
              </svg>
              <span class="visually-hidden">Close video window</span>
            </button>
          </div>
          <iframe class="mfp-iframe" frameborder="0" allowfullscreen title="${el.dataset.iframeTitle}"></iframe>
        </div>`,
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0',
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1',
        },
      },
    },
  
    type: 'iframe',
    removalDelay: 160,
    preloader: false,
  });
}

function init() {
  if (elements.videos.length) {
    elements.videos.forEach(bindVideoHero);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/searches/hero/mando-ui.video-hero.js